import { IBaseDataParser } from "../../core/src/server/parsers/IBaseDataParser";
import { ISBRealityCheckData } from "../data/ISBRealityCheckData";
import RealityCheckModel from "../../core/src/model/RealityCheckModel";
import { IRealityCheckData } from "../../core/src/server/data/IRealityCheckData";

export default class RealityCheckDataParser
    implements IBaseDataParser<IRealityCheckData> {
    public check(data: any): boolean {
        return data;
    }

    public parse(data: any): IRealityCheckData[] {
        const result: IRealityCheckData = {
            hardErrors: data.hardErrors,
            lossLimit: data.lossLimit,
            timeLimit: data.sessionLimitSeconds
                ? data.sessionLimitSeconds * 1000
                : undefined,
            sessionMoneyResult: data.resetedResult,
            status: data.status,
            sessionStartTime:
                !isNaN(data.sessionMinutes)
                    ? // Get current time
                    // new Date().getTime()
                      new Date().getTime() -
                      // And subtract the already passed session time
                      RealityCheckModel.minToMillisec(data.sessionMinutes)
                    : undefined,
            totalBet: data.betSum,
            totalWin: data.winSum,
            totalSessionMinutes:data.totalSessionMinutes,
            totalResult: data.resetedResult,
        };

        console.log("[RealityCheckDataParser] parsedData", result);

        return [result];
    }
}
